import { Observable } from 'rxjs/Observable'
import { combineEpics } from 'redux-observable'
import { fetchOrgUsers } from 'app/modules/user/actions'
import { fetchUsersByPropertyName } from 'app/modules/user/properties/actions'
import * as actions from './actions'
import * as selectors from './selectors'
import { api } from './api'

const fetchUsersAndPropertiesAfterInvite = action$ => {
  return action$
    .ofType(
      actions.sendInvitationsViaSlackCompleted.toString(),
      actions.sendExistingUsersInvitationsViaEmailCompleted.toString(),
      actions.sendInvitationsViaEmailCompleted.toString()
    )
    .switchMap(() => {
      return Observable.of(
        fetchOrgUsers(),
        fetchUsersByPropertyName(['extensionInvited', 'extensionInstalled'])
      )
    })
}

const fetchEndUserCount = action$ => {
  return action$
    .ofType(actions.fetchEndUserCount.toString())
    .pluck('payload')
    .mergeMap(orgId => {
      return api
        .fetchEndUserCount(orgId)
        .map(response => actions.fetchEndUserCountSuccess(response.totalMatching))
        .startWith(actions.fetchEndUserCountPending(orgId))
        .catch(error => {
          return Observable.of(actions.fetchEndUserCountFailed({ error, orgId }))
        })
    })
}

const patchOrgProperties = (action$, { getState }) =>
  action$
    .ofType(actions.patchOrgProperties.toString())
    .pluck('payload')
    .mergeMap((updates) => {
      return api.patchProperties(selectors.orgId(getState()), updates)
        .map((result) => actions.receiveOrgProperties(result))
        .startWith(actions.patchOrgPropertiesPending())
        .catch((error) => Observable.of(actions.patchOrgPropertiesFailure(error)))
    })

const hasLimitedContactsMktEmail = (action$, { getState }) =>
  action$
    .ofType(actions.hasLimitedContactsMktEmail.toString())
    .pluck('payload')
    .mergeMap(() => {
      return api.getHasLimitedContactsMktEmail(selectors.orgId(getState()))
        .map(actions.hasLimitedContactsMktEmailSuccess)
        .startWith(actions.hasLimitedContactsMktEmailPending())
        .catch((error) => Observable.of(actions.hasLimitedContactsMktEmailFailed(error)))
    })

export const epic = combineEpics(
  fetchUsersAndPropertiesAfterInvite,
  fetchEndUserCount,
  patchOrgProperties,
  hasLimitedContactsMktEmail,
)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/org/epic.js